import { useState, useEffect } from "react"
import { useUpdateQuestionSetMutation, useDeleteQuestionSetMutation, useDuplicateQuestionSetMutation } from "./questionSetsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCheck, faCodeBranch, faCodeCompare, faCopy, faPaste, faQuestion, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import { Box, Button, Modal } from '@mui/material'

import 'react-quill/dist/quill.snow.css'; // import the styles
import Questions from "./partial/Questions"

const EditQuestionSetForm = ({ questionSet, courses }) => {
    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateQuestionSet, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateQuestionSetMutation()
    const [duplicate, { }] = useDuplicateQuestionSetMutation()

    const [deleteQuestionSet, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteQuestionSetMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState(questionSet?.title );
    const [course, setCourse] = useState(questionSet?.course?._id );
    const [questions, setQuestions] = useState(questionSet?.questions);
    const [minimumPassed, setMinimumPassed] = useState(
      questionSet?.minimumPassed
    );
    const [isCopy, setIsCopy] = useState("")
    const [openModal, setOpenModal] = useState(false)
    const [multiQuestion, setMultiQuestion] = useState("" );




    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setTitle("");
            setCourse("");
            setQuestions([]);
            setMinimumPassed(0);
            navigate(`/${type}/${groupId}/question-sets`);
        }

    }, [isSuccess, isDelSuccess, navigate])

    const nullQuestionList = questions.filter(c=> !c.title || c.answerOptions.length < 2)
  //console.log(questions)
  const nullAnswers = questions.map(q=>{
    return q.answerOptions?.filter(f=>!f.answerBody ||f.answerBody.length===0)
  })

  const merged = [].concat.apply([], nullAnswers);
    const canSave =[title, course, questions.length, nullQuestionList.length ===0, merged.length ===0 ].every(Boolean) && !isLoading;

    const onSaveQuestionSetClicked = async (e) => {
        if (canSave) {
            await updateQuestionSet({
                id:questionSet.id,
                course,
                title,
                questions,
                minimumPassed,
              })
        }
    }

    const onDeleteQuestionSetClicked = async () => {
      if(window.confirm('are you sure')){
        await deleteQuestionSet({ id: questionSet.id })
      }
    }
    const onDuplicateQuestionSetClicked = async () => {
      if(window.confirm('are you sure')){
        await duplicate({ id: questionSet.id })
      }
    }
    const onCopyObjectClicked =  () => {

      setIsCopy("1" )
      navigator.clipboard.writeText(JSON.stringify(questionSet.questions))
      setTimeout(()=>{
        setIsCopy("")
      }, 3000)
    }
    const addMultiQuestionClicked = () => {
      const oId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
        s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))
      if(!multiQuestion ){
        alert("לא נמצאו רשומות")
        return
      }
      const arr = JSON.parse(multiQuestion)
     
      if(!arr.length){
        alert("לא נמצאו רשומות")
        return
      }
      const newArr = arr.map(q=>{
        const answers = q.answerOptions.map(answer=>{
          const newAnswer = {...answer, _id: oId()}
          return newAnswer
        })
        const el = {...q, _id: oId(), answerOptions:answers}
        return el
      })
     const newQuestion =questions.concat(newArr)
     setOpenModal(false)
     setQuestions(newQuestion)
    }


    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      color:'black',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      pt: 2,
      px: 4,
      pb: 3,
    };
   
    const options = courses.map((course) => {
        return (
          <option key={course.id} value={course.id}>
            {" "}
            {course.name}
          </option>
        );
      });

    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''




    const content = (
        <>
            <p className={errClass}>{errContent}</p>
            <p className='errmsg'>{(questions.length ===0 || nullQuestionList.length ) ? 'יש להכניס שאלות עם לפחות 2 תשובות':''}</p>
      <p className='errmsg'>{(merged.length ) ? 'חובה להכניס תוכן לתשובות':''}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit QuestionSet</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to QuestionSet"
                            onClick={()=>{navigate(`/${type}/${groupId}/question-sets`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>              
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveQuestionSetClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteQuestionSetClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
                        <button
                className="icon-button"
                title="Duplicate"
                onClick={onDuplicateQuestionSetClicked}
            >
                <FontAwesomeIcon icon={faCopy} />
            </button>

            <button
            className="icon-button"
                title="העתקת שאלות"
                onClick={onCopyObjectClicked}
            >
                <FontAwesomeIcon icon={faCodeBranch} />
                
            </button>
            {isCopy && <> <FontAwesomeIcon icon={faCheck} />  Copied! </> }
            <button
            className="icon-button"
                title="Paste Questions"
                onClick={()=>setOpenModal(!openModal)}
            >
                <FontAwesomeIcon icon={faPaste} />
            </button>

                    </div>
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="title">
          Title:
        </label>
        <input
          className={`form__input  ${!title && "form__input--incomplete"}`}
          id="title"
          maxLength={100}
          name="title"
          type="text"
          autoComplete="off"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <div className="form-flex">
          <div className="form-input-container">
            <label
              className="form__label form__checkbox-container"
              htmlFor="course"
            >
              Course:
            </label>
            <select
              id="course"
              name="course"
              className={`form__input  ${!course && "form__input--incomplete"}`}
              value={course}
              onChange={(e) => setCourse(e.target.value)}
            >
              <option></option>
              {options}
            </select>
          </div>
          <div className="form-input-container">
            <label className="form__label" htmlFor="action-order">
              Minimum Passed:
            </label>
            <input
              className={`form__input `}
              id="action-order"
              name="minimumPassed"
              type="number"
              autoComplete="off"
              value={minimumPassed}
              onChange={(e) => setMinimumPassed(e.target.value)}
            />
          </div>
        </div>
        <Questions  questions={questions} setQuestions={setQuestions} />
</div>
               
            </form>
            <Modal
  open={openModal}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
>
  <Box sx={{ ...style, width: 700 }}>
    <h2 id="parent-modal-title"> הדבקת תוכן השאלות תוכן שאלות   </h2>
   <textarea 
   style={{width: "100%", direction: "ltr", textAlign: "left"}}                   
    className={`form__input form__input--text`}
 value={multiQuestion} onChange={(e)=>setMultiQuestion(e.target.value)}></textarea>
   <div className="form-top-bottons">
   <Button variant="contained"  onClick={addMultiQuestionClicked} startIcon={<FontAwesomeIcon style={{marginLeft:"10px"}} icon={faQuestion} />} > הוסף שאלות</Button>
    <Button variant="contained" onClick={()=>setOpenModal(false)} color="error">סגור </Button>

   </div>
 
  </Box>
</Modal>
          
        </>
    )

    return content
}

export default EditQuestionSetForm